// リソースレジストリ。AI秘書が扱えるエンティティはここに登録したものだけ。
// 新しいエンティティへの対応 ＝ 宣言ファイルを1つ書いてここに足す（ツールは増えない）。
import { quoteResource } from './quote.resource';
import { customerResource } from './customer.resource';
import { orderResource } from './order.resource';
import { deliveryResource } from './delivery.resource';
import { invoiceResource } from './invoice.resource';
import { purchaseOrderResource } from './purchase-order.resource';
import { subcontractOrderResource } from './subcontract-order.resource';
import { procurementOrderResource } from './procurement-order.resource';
import type { ResourceDescriptor, ResourceName } from './types';

export { RESOURCE_NAMES, CUSTOMER_STATUS, CUSTOMER_RANK } from './types';
export type { ListFilters, ResourceDescriptor, ResourceName } from './types';

const RESOURCES: Record<ResourceName, ResourceDescriptor> = {
  quote: quoteResource,
  customer: customerResource,
  order: orderResource,
  delivery: deliveryResource,
  invoice: invoiceResource,
  purchase_order: purchaseOrderResource,
  subcontract_order: subcontractOrderResource,
  procurement_order: procurementOrderResource,
};

export function getResource(name: ResourceName): ResourceDescriptor {
  return RESOURCES[name];
}
